import { Shape } from '../yup_types';
import { TFunction } from 'react-i18next';
import * as Yup from 'yup';

export enum CONTACT_FORM_FIELDS {
	FIRST_NAME = 'FirstName',
	LAST_NAME = 'LastName',
	EMAIL = 'Email',
	PHONE = 'Phone',
}

export enum CONTACT_FORM_FIELDS_NAMES {
	FIRST_NAME = 'NEW_APPLICATION.LABEL.FIRST_NAME',
	LAST_NAME = 'NEW_APPLICATION.LABEL.LAST_NAME',
	EMAIL = 'NEW_APPLICATION.LABEL.EMAIL',
	PHONE = 'NEW_APPLICATION.LABEL.PHONE',
}

export type ContactFieldsTypes = {
	[CONTACT_FORM_FIELDS.FIRST_NAME]: string;
	[CONTACT_FORM_FIELDS.LAST_NAME]: string;
	[CONTACT_FORM_FIELDS.EMAIL]: string;
	[CONTACT_FORM_FIELDS.PHONE]: string;
}

export type ContactFieldReturnTypes = {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
}

// @ts-ignore
export const getContactValidationSchema = (t: TFunction): Yup.SchemaOf<ContactFieldsTypes> => Yup.object<Shape<ContactFieldsTypes>>().shape({
	[CONTACT_FORM_FIELDS.FIRST_NAME]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.FIRST_NAME_REQUIRED')),
	[CONTACT_FORM_FIELDS.LAST_NAME]: Yup.string()
		.required(t('NEW_APPLICATION.VALIDATION.LAST_NAME_REQUIRED')),
	[CONTACT_FORM_FIELDS.EMAIL]: Yup.string()
		.email(t('NEW_APPLICATION.VALIDATION.EMAIL_ERROR_TEXT'))
		.required(t('NEW_APPLICATION.VALIDATION.EMAIL_REQUIRED')),
	[CONTACT_FORM_FIELDS.PHONE]: Yup.number()
		.test('is-valid-phone', t('NEW_APPLICATION.VALIDATION.VALID_PHONE'), (value) => {
      if (!value) return true;
      const phoneRegex = /^[0-9]{10,15}$/;
      return phoneRegex.test(value.toString());
    })
		.typeError(t('NEW_APPLICATION.VALIDATION.NUMBER_ERROR_TEXT'))
		.required(t('NEW_APPLICATION.VALIDATION.PHONE_REQUIRED')),
});

export const initialContactValues: ContactFieldsTypes = {
	[CONTACT_FORM_FIELDS.FIRST_NAME]: '',
	[CONTACT_FORM_FIELDS.LAST_NAME]: '',
	[CONTACT_FORM_FIELDS.EMAIL]: '',
	[CONTACT_FORM_FIELDS.PHONE]: '',
};

export const getFormattedContactFormFields = (formikValues): ContactFieldReturnTypes => ({
	firstName: formikValues?.[CONTACT_FORM_FIELDS.FIRST_NAME],
	lastName: formikValues?.[CONTACT_FORM_FIELDS.LAST_NAME],
	email: formikValues?.[CONTACT_FORM_FIELDS.EMAIL],
	phone: formikValues?.[CONTACT_FORM_FIELDS.PHONE],
});

export const convertToContactInitial = (data): ContactFieldsTypes => ({
	[CONTACT_FORM_FIELDS.FIRST_NAME]: data?.primaryContact ? data?.primaryContact.firstName : '',
	[CONTACT_FORM_FIELDS.LAST_NAME]: data?.primaryContact ? data?.primaryContact.lastName : '',
	[CONTACT_FORM_FIELDS.EMAIL]: data?.primaryContact ? data?.primaryContact.email : '',
	[CONTACT_FORM_FIELDS.PHONE]: data?.primaryContact ? data?.primaryContact?.phone : '',
});

export const getFormattedContactData = (data): ContactFieldReturnTypes => ({
	firstName: data?.primaryContact.firstName,
	lastName: data?.primaryContact.lastName,
	email: data?.primaryContact.email ,
	phone: data?.primaryContact?.phone,
});

